import { render, staticRenderFns } from "./guest-table.vue?vue&type=template&id=4dc55545&scoped=true&"
import script from "./guest-table.vue?vue&type=script&lang=ts&"
export * from "./guest-table.vue?vue&type=script&lang=ts&"
import style0 from "./guest-table.vue?vue&type=style&index=0&id=4dc55545&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc55545",
  null
  
)

export default component.exports